import { HTMLAttributes, MouseEvent, MouseEventHandler, createElement, forwardRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText, MenuItem } from 'netline-ui';
import { ProfileMenuItem } from 'types';

import UrlIcon from '../UrlIcon/UrlIcon';

interface UserProfileMenuItemProps extends HTMLAttributes<HTMLLIElement> {
  mobile?: boolean;
  menuItem: ProfileMenuItem;
  onMenuItemClick?: (menuItem: ProfileMenuItem, event: MouseEvent<HTMLLIElement>) => void;
}

const UserProfileMenuItem = forwardRef<HTMLLIElement, UserProfileMenuItemProps>(
  ({ className, mobile = false, menuItem, onMenuItemClick }, ref) => {
    const {
      t,
      i18n: { exists },
    } = useTranslation();
    const handleMenuItemClick: MouseEventHandler<HTMLLIElement> = useCallback(
      (event) => {
        onMenuItemClick?.(menuItem, event);
      },
      [onMenuItemClick, menuItem],
    );

    const { text, icon } = menuItem;

    return createElement(
      mobile ? ListItem : MenuItem,
      { ref, className, onClick: handleMenuItemClick },
      <>
        {icon && (
          <ListItemIcon>
            <UrlIcon nameOrUrl={icon} />
          </ListItemIcon>
        )}
        <ListItemText>{exists(text) ? t(text) : text}</ListItemText>
      </>,
    );
  },
);

export default UserProfileMenuItem;
